import $ from "jquery";
import Cookies from "js-cookie";
import anime from "animejs";

/**
 * Check if cookie exists and set SF_ID
 */
$(function () {
    if (Cookies.get("sb-viewed-templates")) {
        var templates = JSON.parse(Cookies.get("sb-viewed-templates"));

        // if the array includes SF_ID
        if (templates.includes(SF_ID)) {
            // delete SF_ID from its current location
            var index = templates.indexOf(SF_ID);
            if (index > -1) {
                templates.splice(index, 1);
            }
            // Add SF_ID to the end
            templates.push(SF_ID);
        } else {
            // Add SF_ID to the end
            templates.push(SF_ID);
        }

        Cookies.set("sb-viewed-templates", JSON.stringify(templates), {
            expires: 14,
            secure: true,
        });
    } else {
        Cookies.set("sb-viewed-templates", JSON.stringify([SF_ID]), {
            expires: 14,
            secure: true,
        });
    }

    // Trigger showing of template cta after slight delay (once)
    setTimeout(() => {
        $("body").addClass("s_show-template-cta");
    }, 250);
});
